










import { Component, Vue } from "vue-property-decorator";

import HomeFooter from "@/components/footer.vue";
import HomeHeader from "@/components/header.vue";
import Fab from "@/components/fab.vue";
import WhatIsVibrix from "@/components/whatIsVibrix.vue";
import Landing from "@/components/Landing.vue";

@Component({
    components: { HomeFooter, HomeHeader, Fab, WhatIsVibrix, Landing },
})
export default class Home extends Vue {}
